import React from 'react';
import Img from "gatsby-image";
import styles from './Story.module.scss';
import Menu, { MenuList, MenuListItem, MenuListItemText } from '@material/react-menu';
import MaterialIcon from '@material/react-material-icon';
import { strings, slugs } from '../../utils/localization';
import { navigate } from 'gatsby';
import StateLink from '../StateLink';
import FontIcon from '../FontIcons/FontIcon';
import { isFavorite, addFavorite, removeFavorite } from '../utils/favoriteManager';
import kebabCase from 'lodash/kebabCase';

const Story = ({ edge: maybeEdge, path, className, style, info = true, children }) => {
    const [more, setMore] = React.useState(false)
    const [coordinates, setCoordinates] = React.useState(undefined)
    const [edge, setEdge] = React.useState(maybeEdge)
    const [favorite, setFavorite] = React.useState(maybeEdge ? isFavorite(maybeEdge.node.fields.slug) : isFavorite(path))

    if (path) {
        React.useEffect(() => {
            fetch(`${path.slice(0, -1)}.json`)
                .then((response) => {
                    return response.json();
                })
                .then((edge) => {
                    setEdge(edge);
                });
        }, []);
    }

    const toggleFavourite = (edge, value) => {
        if (value) {
            addFavorite(edge.node.fields.slug);
        } else {
            removeFavorite(edge.node.fields.slug);
        }

        setFavorite(value)
        window.location.href='/'
    }

    if (!edge) {
        return (<div className={`${styles.storycontainer} ${className}`} style={style}>
            <div className={styles.emptycontainer}></div>
            <div>
                <div className={styles.secondInfo} >&nbsp;</div>
            </div>
        </div>);
    }

    return (
        <div className={`${styles.storycontainer} ${className}`} style={style}>
            <MaterialIcon
                className={styles.more}
                aria-label="Share"
                hasRipple
                icon='more_vert'
                onClick={() => { setCoordinates({ x: event.clientX, y: event.clientY }); setMore(true); }}
            />
            <Menu
                open={more}
                onClose={() => setMore(false)}
                coordinates={coordinates}
            >
                <MenuList>
                    <MenuListItem onClick={() => navigate(edge.node.fields.authorSlug)}>
                        <MenuListItemText primaryText={`${strings.moreBy} ${edge.node.frontmatter.author}...`} />
                    </MenuListItem>
                    {edge.node.frontmatter.tags &&
                        edge.node.frontmatter.tags.map(tag =>
                            <MenuListItem key={tag} onClick={() => navigate(`${slugs.categories}${kebabCase(tag)}/`)}>
                                <MenuListItemText primaryText={`${strings.moreFrom} ${tag}...`} />
                            </MenuListItem>
                        )
                    }
                    <MenuListItem onClick={() => toggleFavourite(edge, !isFavorite(edge.node.fields.slug))}>
                        <MenuListItemText primaryText={`${isFavorite(edge.node.fields.slug) ? strings.removeFromFavorites : strings.addToFavorites}`} />
                    </MenuListItem>
                </MenuList>
            </Menu>
            <StateLink style={!edge.node.fields.image ? { backgroundColor: 'steelblue' } : null} className={styles.story} to={edge.node.fields.slug}>
                {edge.node.fields.image && <Img className={styles.image} fixed={edge.node.fields.image.childImageSharp.large} />}
                <div className={edge.node.frontmatter.style === 'white' || !edge.node.fields.image ? styles.titlewhite : (edge.node.frontmatter.style === 'black' ? styles.titleblack : styles.title)}>{edge.node.frontmatter.title}</div>
                <div className={edge.node.frontmatter.style === 'black' ? styles.authorblack : styles.author}>{edge.node.frontmatter.author}</div>
                {favorite && <FontIcon className={styles.favorite}>visibility</FontIcon>}
            </StateLink>
            {info &&
                <div>
                    <div className={styles.info}>{edge.node.frontmatter.title}</div>
                    {/* <div className={styles.secondInfo}><FontIcon style={{ fontSize: "10px", color: "#858aa5" }}>access_time</FontIcon> {minToHours(edge.node.timeToRead)}</div> */}
                </div>
            }
            {/* {edge.node.fields.audio && <FontIcon className={styles.audio}>headset</FontIcon>} */}
            {children}
        </div>
    );
}

export default Story

